import { Info } from "lucide-react";
import React from "react";
import { Tooltip } from "@mantine/core";
import { DocumentProcessingJobStatus } from "../services/model/DocumentProcessingJob";

const STATUSES_WITH_TOOLTIPS = new Set([
  DocumentProcessingJobStatus.MATCHING_TIMEOUT,
  DocumentProcessingJobStatus.PARTIALLY_MATCHED,
  DocumentProcessingJobStatus.MATCHES_NEEDED,
  DocumentProcessingJobStatus.FAILED,
  DocumentProcessingJobStatus.PROCESSING_TIMEOUT,
  DocumentProcessingJobStatus.FINALIZED_WITH_ERRORS,
]);

const STATUS_REASON_OVERRIDES: { [key: string]: string } = {
  "Exception raised during processing":
    "Something went wrong while processing the file.",
  "Failed to upload the Document to GCP Bucket in the allowed time":
    "The upload took too long — please try again.",
  "Document failed to upload to GCP Bucket":
    "The file couldn't be uploaded — please try again.",
  "Failed during finalizing step! Did not finalize all matched documents.":
    "The upload was incomplete - please recheck and try again.",
  "No matches found": "No employee records matched this file.",
};

type UploadStatusTooltipProps = {
  status: string;
  statusReason: string;
};

const UploadStatusTooltip: React.FC<UploadStatusTooltipProps> = ({
  status,
  statusReason,
}) => {
  if (!statusReason) return null;

  const showTooltip = STATUSES_WITH_TOOLTIPS.has(status);
  if (!showTooltip) return null;

  const tooltipMessage = STATUS_REASON_OVERRIDES[statusReason] ?? statusReason;

  return (
    <Tooltip
      label={tooltipMessage}
      arrowSize={3}
      withArrow
      width={250}
      wrapLines
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          paddingRight: "1px", // Matching 4px padding of status label (1px + 3px padding of icon)
        }}
      >
        <Info size={14} />
      </div>
    </Tooltip>
  );
};

export default UploadStatusTooltip;
